import { gql } from '__generated__';

export default gql(`
  query GetTeams(
    $project_id: ID!,
    $page: Int,
    $per_page: Int,
    $search: String,
    $events: [ID!],
    $team_types: [ID!],
    $min_size: Int,
    $max_size: Int,
  ) {
    project(id: $project_id) {
      id
      events {
        total
      }
      teams(
        page: $page,
        per_page: $per_page,
        events: $events,
        team_types: $team_types,
        search: $search,
        min_size: $min_size,
        max_size: $max_size,
      ) {
        data {
          id
          title
          participants_count
          team_type {
            id
            title
          }
          event {
            id
            title
          }
          captain {
            id
            full_name
          }
        }
        current_page
        last_page
        per_page
        total
        has_more_pages
      }
    }
  }
`);
